export default "__VITE_ASSET__BwKIc0X2__"